<app-shared-loading *ngIf="loading"></app-shared-loading>
<div class="general-title">
    <h1 class="pl-1 title">{{ 'cash-Subtitle' | translation | async }}</h1>
</div>
<app-return-methods [itsMobileCtrl]="true" [unique]="''" (RT)="changeMethod()"></app-return-methods>
<div class="contentBox">
    <div class="col-3">
        <div class="info-logo-container">
            <img src="{{ info.logo }}" class="payment_method_no_interactive" alt="Tarjeta de crédito" />
        </div>
    </div>
    <div class="col-7">
        <div class="methodInfo">
            <app-return-methods [itsMobileCtrl]="false" [unique]="''" (RT)="changeMethod()"></app-return-methods>
            <h1>{{ 'cc-Title' | translation | async }}</h1>
            <form [formGroup]="form" class="methodForm">
                <app-buyer-information [info]="info" [buyerInfoControl]="buyerInfoControl"></app-buyer-information>
                <mat-form-field appearance="outline" [ngClass]="{ disabledInput: isControlReadOnly('name') }">
                    <mat-label>{{ 'cc-Name-Input' | translation | async }}</mat-label>
                    <input
                        autocomplete="off"
                        type="text"
                        matInput
                        name="name"
                        placeholder="{{ 'cc-Name-Input' | translation | async }}"
                        formControlName="name"
                        [readonly]="isControlReadOnly('name')"
                    />
                </mat-form-field>
                <ng-container *ngFor="let validation of errorsMessages.name">
                    <div class="error-message" *ngIf="form.get('name').hasError(validation.type) && (form.get('name').dirty || form.get('name').touched)">
                        {{ validation.message }}
                    </div>
                </ng-container>
                <mat-form-field appearance="outline" [ngClass]="{ disabledInput: isControlReadOnly('lastname') }">
                    <mat-label>{{ 'cc-LastName-Input' | translation | async }}</mat-label>
                    <input
                        autocomplete="off"
                        type="text"
                        matInput
                        name="lastname"
                        placeholder="{{ 'cc-LastName-Input' | translation | async }}"
                        formControlName="lastname"
                        [readonly]="isControlReadOnly('lastname')"
                    />
                </mat-form-field>
                <ng-container *ngFor="let validation of errorsMessages.lastName">
                    <div class="error-message" *ngIf="form.get('lastname').hasError(validation.type) && (form.get('lastname').dirty || form.get('lastname').touched)">
                        {{ validation.message }}
                    </div>
                </ng-container>
                <mat-form-field appearance="outline" [ngClass]="{ disabledInput: isControlReadOnly('typeDI') }">
                    <mat-label>{{ 'forms-TypeDoc-Input' | translation | async }}</mat-label>
                    <mat-select
                        placeholder="{{ 'forms-TypeDoc-Input' | translation | async }}"
                        formControlName="typeDI"
                        ngDefaultControl
                        (selectionChange)="activateCallConfigurableList()"
                        [readonly]="isControlReadOnly('typeDI')"
                    >
                        <mat-option [value]="document.VALUE" *ngFor="let document of listOfDocuments">{{ document.TEXT }} </mat-option>
                    </mat-select>
                </mat-form-field>
                <ng-container *ngFor="let validation of errorsMessages.typeDI">
                    <div class="error-message" *ngIf="form.get('typeDI').hasError(validation.type) && (form.get('typeDI').dirty || form.get('typeDI').touched)">
                        {{ validation.message }}
                    </div>
                </ng-container>
                <mat-form-field appearance="outline" [ngClass]="{ disabledInput: isControlReadOnly('di') }">
                    <mat-label>{{ 'forms-NumDoc-Input' | translation | async }}</mat-label>
                    <input
                        autocomplete="off"
                        type="text"
                        placeholder="{{ 'forms-NumDoc-Input' | translation | async }}"
                        matInput
                        name="di"
                        minlength="6"
                        formControlName="di"
                        [readonly]="isControlReadOnly('di')"
                    />
                </mat-form-field>
                <ng-container *ngFor="let validation of errorsMessages.di">
                    <div class="error-message" *ngIf="form.get('di').hasError(validation.type) && (form.get('di').dirty || form.get('di').touched)">
                        {{ validation.message }}
                    </div>
                </ng-container>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'cc-NumCard-Input' | translation | async }}</mat-label>
                    <input
                        autocomplete="off"
                        type="text"
                        name="cardNumber"
                        matInput
                        placeholder="{{ 'cc-NumCard-Input' | translation | async }}"
                        required
                        formControlName="cardNumber"
                        (focusout)="activateCallConfigurableList()"
                    />
                </mat-form-field>
                <ng-container *ngFor="let validation of errorsMessages.creditCard">
                    <div class="error-message" *ngIf="form.get('cardNumber').hasError(validation.type) && (form.get('cardNumber').dirty || form.get('cardNumber').touched)">
                        {{ validation.message }}
                    </div>
                </ng-container>
                <div class="expirationContainer">
                    <mat-form-field appearance="outline">
                        <mat-label>{{ 'cc-ExpirationYear' | translation | async }}</mat-label>
                        <mat-select required formControlName="expirationYear" ngDefaultControl>
                            <mat-option [value]="year.slice(2, 4)" *ngFor="let year of listOfYears">{{ year }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>{{ 'cc-ExpirationMonth' | translation | async }}</mat-label>
                        <mat-select required formControlName="expirationMonth" ngDefaultControl>
                            <mat-option [value]="month" *ngFor="let month of listOfMonths">{{ month }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="expirationContainer">
                    <div class="col">
                        <ng-container *ngFor="let validation of errorsMessages.expirationYear">
                            <div class="error-message" *ngIf="form.get('expirationYear').hasError(validation.type) && (form.get('expirationYear').dirty || form.get('expirationYear').touched)">
                                {{ validation.message }}
                            </div>
                        </ng-container>
                    </div>
                    <div class="col">
                        <ng-container *ngFor="let validation of errorsMessages.expirationMonth">
                            <div class="error-message" *ngIf="form.get('expirationMonth').hasError(validation.type) && (form.get('expirationMonth').dirty || form.get('expirationMonth').touched)">
                                {{ validation.message }}
                            </div>
                        </ng-container>
                    </div>
                </div>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'cc-CodVerify-Input' | translation | async }}</mat-label>
                    <input
                        autocomplete="off"
                        [type]="cvvIsFocus ? 'text' : 'password'"
                        (focus)="cvvIsFocus = true"
                        (focusout)="cvvIsFocus = false"
                        matInput
                        name="cvv"
                        placeholder="{{ 'cc-CodVerify-Input' | translation | async }}"
                        formControlName="cvv"
                    />
                </mat-form-field>
                <ng-container *ngFor="let validation of errorsMessages.cvv">
                    <div class="error-message" *ngIf="form.get('cvv').hasError(validation.type) && (form.get('cvv').dirty || form.get('cvv').touched)">
                        <ng-container *ngIf="validation.type === errorsMessages.cvv[2].type || CVV === 3; else fourDigits">
                            {{ validation.message.replace('%d', '3') }}
                        </ng-container>
                        <ng-template #fourDigits>
                            {{ validation.message.replace('%d', '4') }}
                        </ng-template>
                    </div>
                </ng-container>
                <mat-form-field *ngIf="cuota" appearance="outline">
                    <mat-label>{{ 'cc-Quotes-Input' | translation | async }}</mat-label>
                    <mat-select formControlName="cuotes" placeholder="{{ 'cc-Quotes-Input' | translation | async }}">
                        <mat-option *ngFor="let i of coutesArray" [value]="i">
                            {{ i }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <ng-container *ngFor="let validation of errorsMessages.cuotes">
                    <div class="error-message" *ngIf="form.get('cuotes').hasError(validation.type) && (form.get('cuotes').dirty || form.get('cuotes').touched)">
                        {{ validation.message }}
                    </div>
                </ng-container>
                <ng-container *ngIf="activeDirectionForm">
                    <ng-container>
                        <p>Dirección de facturación</p>
                    </ng-container>
                    <div class="addressContainer">
                        <!-- Paises -->
                        <div class="col">
                            <mat-form-field appearance="outline" [disabled]="!countries">
                                <mat-label>{{ 'cc-Country-Input' | translation | async }}</mat-label>
                                <mat-select required formControlName="billAddrCountry" [(ngModel)]="selectedCountry" (selectionChange)="selectCountry()">
                                    <mat-option *ngFor="let country of countries" [value]="country">{{ country }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <!-- Estados -->
                        <div class="col" *ngIf="!disabledState">
                            <mat-form-field appearance="outline">
                                <mat-label>{{ 'cc-State-Input' | translation | async }}</mat-label>
                                <mat-select required formControlName="billAddrState" [(ngModel)]="selectedState" [disabled]="disabledState" (selectionChange)="selectState()">
                                    <mat-option *ngFor="let state of states" [value]="state | json">{{ state }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col" *ngIf="disabledState">
                            <mat-form-field appearance="outline">
                                <mat-label>{{ 'cc-State-Input' | translation | async }}</mat-label>
                                <input autocomplete="off" type="text" matInput name="billAddrState" placeholder="{{ 'cc-State-Input' | translation | async }}" formControlName="billAddrState" />
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="addressContainer">
                        <div class="col">
                            <ng-container *ngIf="form.get('billAddrCountry').invalid && (form.get('billAddrCountry').dirty || form.get('billAddrCountry').touched)">
                                <div class="error-message">
                                    <ng-container *ngIf="form.get('billAddrCountry').errors.required"> * Este campo es requerido </ng-container>
                                </div>
                            </ng-container>
                        </div>
                        <!-- Estados error-->
                        <div class="col">
                            <ng-container *ngIf="form.get('billAddrState').invalid && (form.get('billAddrState').dirty || form.get('billAddrState').touched)">
                                <div class="error-message">
                                    <ng-container *ngIf="form.get('billAddrState').errors.required"> * Este campo es requerido </ng-container>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <div class="col">
                        <!-- Ciudades -->
                        <mat-form-field appearance="outline" *ngIf="!disabledCity">
                            <mat-label>{{ 'cc-City-Input' | translation | async }}</mat-label>
                            <mat-select required formControlName="billAddrCity" [disabled]="disabledCity">
                                <mat-option *ngFor="let city of cities" [value]="city | json">{{ city }}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <div class="col" *ngIf="disabledCity">
                            <mat-form-field appearance="outline">
                                <mat-label>{{ 'cc-City-Input' | translation | async }}</mat-label>
                                <input autocomplete="off" type="text" matInput name="billAddrCity" placeholder="{{ 'cc-City-Input' | translation | async }}" formControlName="billAddrCity" />
                            </mat-form-field>
                        </div>

                        <!-- Error ciudades -->
                        <ng-container *ngIf="form.get('billAddrCity').invalid && (form.get('billAddrCity').dirty || form.get('billAddrCity').touched)">
                            <div class="error-message">
                                <ng-container *ngIf="form.get('billAddrCity').errors.required"> * Este campo es requerido </ng-container>
                            </div>
                        </ng-container>
                    </div>

                    <mat-form-field appearance="outline" [ngClass]="{ disabledInput: isControlReadOnly('billAddrLine1') }">
                        <mat-label>{{ 'cc-billAddrLine1B-Input' | translation | async }}</mat-label>
                        <input
                            autocomplete="off"
                            type="text"
                            matInput
                            name="address"
                            placeholder="Dirección, nombre de compañia, etc..."
                            formControlName="billAddrLine1"
                            [readonly]="isControlReadOnly('billAddrLine1')"
                        />
                    </mat-form-field>
                    <ng-container class="first-field" *ngIf="form.get('billAddrLine1').invalid && (form.get('billAddrLine1').dirty || form.get('billAddrLine1').touched)">
                        <div class="error-message">
                            <ng-container *ngIf="form.get('billAddrLine1').errors.required"> * Este campo es requerido </ng-container>
                            <ng-container *ngIf="form.get('billAddrLine1').errors.maxlength"> * Maximo 50 caracteres </ng-container>
                        </div>
                    </ng-container>
                    <mat-form-field appearance="outline" class="second-field" [ngClass]="{ disabledInput: isControlReadOnly('billAddrLine2') }">
                        <mat-label>{{ 'cc-billAddrLine2A-Input' | translation | async }}</mat-label>
                        <input
                            autocomplete="off"
                            type="text"
                            matInput
                            name="address"
                            placeholder="sector, barrio, area..."
                            formControlName="billAddrLine2"
                            [readonly]="isControlReadOnly('billAddrLine2')"
                        />
                    </mat-form-field>
                    <ng-container *ngIf="form.get('billAddrLine2').invalid && (form.get('billAddrLine2').dirty || form.get('billAddrLine2').touched)">
                        <div class="error-message">
                            <ng-container *ngIf="form.get('billAddrLine2').errors.required"> * Este campo es requerido </ng-container>
                            <ng-container *ngIf="form.get('billAddrLine2').errors.maxlength"> * Maximo 50 caracteres </ng-container>
                        </div>
                    </ng-container>

                    <mat-form-field appearance="outline" [ngClass]="{ disabledInput: isControlReadOnly('billAddrPostCode') }">
                        <mat-label>{{ 'cc-billAddrPostCode-Input' | translation | async }}</mat-label>
                        <input
                            autocomplete="off"
                            type="text"
                            matInput
                            name="reference"
                            placeholder="{{ 'cc-billAddrPostCode-Input' | translation | async }}"
                            formControlName="billAddrPostCode"
                            [readonly]="isControlReadOnly('billAddrPostCode')"
                        />
                    </mat-form-field>
                    <ng-container *ngIf="form.get('billAddrPostCode').invalid && (form.get('billAddrPostCode').dirty || form.get('billAddrPostCode').touched)">
                        <div class="error-message">
                            <ng-container *ngIf="form.get('billAddrPostCode').errors.required"> * Este campo es requerido </ng-container>
                            <ng-container *ngIf="form.get('billAddrPostCode').errors.pattern"> * Solo numeros </ng-container>
                            <ng-container *ngIf="form.get('billAddrPostCode').errors.maxlength"> * Maximo 16 caracteres </ng-container>
                            <ng-container *ngIf="form.get('billAddrPostCode').errors.minlength"> * Minimo 3 caracteres </ng-container>
                        </div>
                    </ng-container>
                </ng-container>
                <iframe name="iframeContainer" id="iframe" class="iframe-container"></iframe>
                <div name="frameContainer" id="frameContainer"></div>
                <app-privacy-conditions (formPrivacyUpdate)="formPrivacyUpdate($event)"></app-privacy-conditions>
            </form>
        </div>
        <app-buttons-bar [template]="template" [valid]="completedForms()" (PAY)="validData()"></app-buttons-bar>
    </div>
</div>
